import React from 'react'


const Loading = () => {
    return (
        <>
            <br /><br /><br />
            <br /><br /><br />
            <div className="spinner">
                <div className="loader" id="loader"></div>
                <div className="loader" id="loader2"></div>
                <div className="loader" id="loader3"></div>
                <div className="loader" id="loader4"></div>
                <span id="text">LOADING...</span><br />
            </div>
        </>
    )
}

export default Loading 